import React from 'react';
import {Container, Grid} from "@mui/material";
import {useMediaQuery} from "react-responsive";

import './styles.css';
import stepBar from '../../../assets/images/plannin-step-bar.svg'

const Planning = () => {
    const max730 = useMediaQuery({maxWidth: 730})

    return (
        <div className="white-planning-block">
            <Container maxWidth={false} sx={{maxWidth: "1248px"}}>
                <h3 className="white-planning-title" style={max730 ? {marginBottom:"36px", fontSize:"38px"} : {}}>Planning</h3>
                <div style={max730 ? {display: "flex", flexDirection: "row-reverse"} : {}}>
                    {max730 ? (
                        <div className="vertical-gradient">
                            <div className="gradient-circle gradient-circle-1"></div>
                            <div className="gradient-circle gradient-circle-2"></div>
                            <div className="gradient-circle gradient-circle-3"></div>
                        </div>
                    ) : (
                        <img src={stepBar} alt="step-bar" className="white-planning-step-bar"/>
                    )}

                    <Grid container>
                        <Grid item xs={12} sm1={3} style={{marginBottom: "32px", marginRight: "50px"}}>
                            <h2 className="white-planning-title">Incoming info</h2>
                            <p className="white-planning-text">Client had ideas on:</p>
                            <ul className="black-dots-list">
                                <li>Business model</li>
                                <li>Initial concept</li>
                                <li>Feature breakdown list</li>
                            </ul>
                        </Grid>
                        <Grid item xs={12} sm1={3.3} style={{marginBottom: "32px", marginRight: "60px"}}>
                            <h2 className="white-planning-title">Analysis</h2>
                            <p className="white-planning-text">We analyze the client’s requirements</p>
                            <ul className="black-dots-list">
                                <li> Requirement Gathering</li>
                                <li> Business Analyst Engagement</li>
                                <li> Meetings and Discussions</li>
                            </ul>
                        </Grid>
                        <Grid item xs={12} sm1={3.5} style={{marginBottom: "32px"}}>
                            <h2 className="white-planning-title">Outcomes</h2>
                            <p className="white-planning-text">As a result, we provide client with:</p>
                            <ul className="black-dots-list">
                                <li>Specification Document</li>
                                <li>Design Mockups</li>
                                <li>Project Roadmap</li>
                                <li>Clickable prototype</li>
                                <li>Project estimate</li>
                            </ul>
                        </Grid>
                    </Grid>
                </div>
            </Container>
        </div>
    )
        ;
};

export default Planning;